@if (!asList && openTicketCount > 0) {
<div>
    <div class="material-icons flag-red">flag</div>
    <a class="nova__link" (click)="onTicketSelected()">{{openTicketCount}} open ticket(s)</a>
</div>
}

@if (asList && openTickets?.length > 0) {
<div>
    <a href="javascript:void(0)" [matMenuTriggerFor]="ticketMenu">
        <em class="material-icons flag-red alert app-candidates-grid-alert">flag</em>
        {{openTickets?.length}} open ticket(s)
    </a>
    <mat-menu #ticketMenu="matMenu" class="prestart-contextmenu" [overlapTrigger]="false">
        <table class="context-table" aria-label="tickets">
            <tr>
                <th>
                    Ticket
                </th>
                <th>
                    Category
                </th>
            <tr>
            @for (ticket of openTickets; track ticket) {
                <tr>
                    <td>
                        <a target="_blank" href="/#/travelx/tickets/{{ticket.id}}">{{ticket.id}}</a>
                    </td>
                    <td>
                        {{ticket.category}}
                    </td>
                </tr>
            }
        </table>
    </mat-menu>
</div>
}